import {useMutation} from "@tanstack/react-query";
import {assignUserRoleMutationOptions} from "./assign-user-role.mutation-options";

export function useAssignUserRole(userId: string) {
  return useMutation(assignUserRoleMutationOptions(userId));
}
